"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragDropContext = exports.Draggable = exports.Droppable = exports.DraggableListControls = exports.DraggableControl = exports.DraggableList = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
function DraggableList({ data, setData, render, getDisabled, }) {
    const sensorAPIRef = (0, react_1.useRef)(null);
    const onDragEnd = ({ destination, source }) => {
        if (destination) {
            setData((curr) => reorder(curr, source.index, destination.index));
        }
    };
    const moveByOne = (num) => (dir) => {
        if ((num === 0 && dir === 'up') ||
            (num === data.length - 1 && dir === 'down')) {
            return;
        }
        const newOrder = reorder(data, num, num + (dir === 'up' ? -1 : 1));
        setData(newOrder);
    };
    const remove = (id) => {
        const newData = data.filter((elem) => elem.id !== id);
        setData(newData);
    };
    const lift = (quoteId) => {
        const api = sensorAPIRef.current;
        if (!api) {
            return null;
        }
        const preDrag = api.tryGetLock(quoteId);
        if (!preDrag) {
            return null;
        }
        return preDrag.snapLift();
    };
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.DragDropContext, Object.assign({ onDragEnd: onDragEnd, sensors: [
            (api) => {
                sensorAPIRef.current = api;
            },
        ] }, { children: (0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Droppable, Object.assign({ droppableId: "list" }, { children: (provided) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: (r) => provided.innerRef(r) }, provided.droppableProps, { children: [data.map((stateElement, index) => ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Draggable, Object.assign({ draggableId: stateElement.id, index: index, isDragDisabled: getDisabled === null || getDisabled === void 0 ? void 0 : getDisabled(stateElement) }, { children: (draggableProps) => render(stateElement, draggableProps, moveByOne(index), () => remove(stateElement.id), lift) }), stateElement.id))), provided.placeholder] }))) })) })));
}
exports.DraggableList = DraggableList;
const ListControlWrap = app_1.styled.div `
  display: flex;
  flex-direction: column;
`;
const ListTopBar = app_1.styled.div `
  display: flex;
  justify-content: space-between;
`;
const ControlsWrap = app_1.styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
exports.DraggableControl = app_1.styled.div `
  color: ${(theme) => theme.colors.gray};
  padding-left: 0.75rem;
  cursor: pointer;

  pointer-events: ${(_, { $disabled }) => ($disabled ? 'none' : 'all')};

  &:hover {
    color: ${(theme) => theme.colors.primary.deep};
  }

  > svg {
    height: 1.375rem !important;
    height: 1.375rem !important;
  }
`;
function DraggableListControls({ id, draggableProps, moveByOne, remove, lift, headerComponent, components, className, disabled, children, }) {
    const { move: Move, up: Up, down: Down, bin: Bin } = components !== null && components !== void 0 ? components : {};
    const handleMoveByOne = (dir) => {
        const lifted = lift(id);
        if (dir === 'up') {
            lifted === null || lifted === void 0 ? void 0 : lifted.moveUp();
        }
        else {
            lifted === null || lifted === void 0 ? void 0 : lifted.moveDown();
        }
        setTimeout(() => {
            lifted === null || lifted === void 0 ? void 0 : lifted.drop();
            moveByOne(dir);
        }, 300);
    };
    return ((0, jsx_runtime_1.jsxs)(ListControlWrap, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)(ListTopBar, { children: [headerComponent, !disabled && ((0, jsx_runtime_1.jsxs)(ControlsWrap, { children: [(0, jsx_runtime_1.jsx)(exports.DraggableControl, Object.assign({}, draggableProps.dragHandleProps, { children: Move ? (0, jsx_runtime_1.jsx)(Move, {}) : '✥' })), (0, jsx_runtime_1.jsx)(exports.DraggableControl, Object.assign({ onClick: () => handleMoveByOne('up') }, { children: Up ? (0, jsx_runtime_1.jsx)(Up, {}) : '↑' })), (0, jsx_runtime_1.jsx)(exports.DraggableControl, Object.assign({ onClick: () => handleMoveByOne('down') }, { children: Down ? (0, jsx_runtime_1.jsx)(Down, {}) : '↓' })), (0, jsx_runtime_1.jsx)(exports.DraggableControl, Object.assign({ onClick: remove }, { children: Bin ? (0, jsx_runtime_1.jsx)(Bin, {}) : '🗑' }))] }))] }), children] })));
}
exports.DraggableListControls = DraggableListControls;
var react_beautiful_dnd_2 = require("react-beautiful-dnd");
Object.defineProperty(exports, "Droppable", { enumerable: true, get: function () { return react_beautiful_dnd_2.Droppable; } });
Object.defineProperty(exports, "Draggable", { enumerable: true, get: function () { return react_beautiful_dnd_2.Draggable; } });
Object.defineProperty(exports, "DragDropContext", { enumerable: true, get: function () { return react_beautiful_dnd_2.DragDropContext; } });
